// extracted by css-extract-rspack-plugin
export default {"animated":"AnnotationIcon-module__animated__TTdCs","fadeIn":"AnnotationIcon-module__fadeIn__X7I4R"};